import React from 'react';
import { useNavigate } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';

interface AppHeaderProps {
  title: string;
  backLabel?: string;
  onBack?: () => void;
  showBack?: boolean;
  rightElement?: React.ReactNode;
  transparent?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  title,
  backLabel = "Retour",
  onBack,
  showBack = true,
  rightElement,
  transparent = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <header 
      className={`sticky top-0 z-50 w-full flex items-center justify-between px-4 py-3 
        ${transparent 
          ? 'bg-transparent' 
          : 'bg-white/85 dark:bg-background-dark/85 backdrop-blur-xl border-b border-gray-100 dark:border-white/5'
        }`}
    >
      <div className="flex-1 flex items-center">
        {showBack && (
          <button
            onClick={handleBack}
            className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl text-gray-600 dark:text-gray-400 
              hover:text-primary dark:hover:text-primary hover:bg-primary/5 dark:hover:bg-primary/10 
              transition-all duration-200 group active:scale-95"
          >
            <div className="flex items-center justify-center size-8 rounded-full bg-gray-100 dark:bg-white/5 
              group-hover:bg-primary/10 dark:group-hover:bg-primary/20 group-hover:text-primary transition-colors">
              <MaterialIcon icon="arrow_back" style={{ fontSize: 20 }} />
            </div>
            <span className="text-xs font-bold uppercase tracking-widest">{backLabel}</span>
          </button>
        )}
      </div>

      <div className="flex-[2] flex justify-center overflow-hidden">
        <h1 className="text-slate-900 dark:text-white text-base font-bold leading-tight tracking-tight truncate px-2">
          {title}
        </h1>
      </div>

      <div className="flex-1 flex justify-end">
        {rightElement || <div className="size-8" />}
      </div>
    </header>
  );
};

export default AppHeader;
